'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsMobile = exports.getWidth = exports.getTabletWidth = exports.getHeight = undefined;

var _reselect = require('reselect');

var getHeight = exports.getHeight = function getHeight(state) {
  return state.environment.height;
};

var getTabletWidth = exports.getTabletWidth = function getTabletWidth(state) {
  return (
    /*state.environment.tabletWidth*/
    736
  );
}; //TODO


var getWidth = exports.getWidth = function getWidth(state) {
  return state.environment.width;
};

var getIsMobile = exports.getIsMobile = (0, _reselect.createSelector)(getWidth, getTabletWidth, function (width) {
  return width < getTabletWidth;
});